import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
	@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@1,800&family=Ubuntu:wght@400;500;700&display=swap');
	body {
		font-family: Ubuntu;
	}
`;
